export default (document.body.dataset ? document.body.dataset.appVersion : null) || "unknown";
